import { Checkbox, Space, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useOrderTerms } from '../../hooks/useOrderTerms';
import { IOrder } from '../../types/order';

interface IOrderTermsOfServiceButtonProps {
    order: IOrder;
    onTermsAccepted: () => void;
}

function OrderTermsOfServiceButton({ onTermsAccepted, order }: IOrderTermsOfServiceButtonProps) {
    const { acceptTermsOfService, loading } = useOrderTerms(order);
    const { t } = useTranslation();

    const onAccepted = async () => {
        const result = await acceptTermsOfService();
        if (result) {
            if (typeof onTermsAccepted === 'function') {
                onTermsAccepted();
            }
        }
    };

    return (
        <Spin spinning={loading}>
            <Space>
                <Checkbox
                    checked={order.terms_of_service_accepted}
                    onChange={onAccepted}
                />
                <span>{t('acceptTermsOfService')}</span>
            </Space>
        </Spin>
    );
}

export default OrderTermsOfServiceButton;
